<template>
    <div class="w-full">
        <div class="w-full" v-html="form"></div>

        <button v-on:click="formSubmit()" v-if="allowSubmit" class="mx-auto lg:mx-0 hover:underline gradient hover:text-white text-white font-bold rounded-full my-3 py-4 px-8 shadow-lg">
            Submit
        </button>
    </div>
</template>

<script>
    export default {
        props: [
            'action',
            'sitekey',
            'url',
        ],
        data() {
            return {
                // track submit button state
                allowSubmit: true,

                // html form will be loaded in to this
                form: null,

                // title says it all, right!?
                googleRecaptchaConfig: {
                    siteKey: this.sitekey,
                    action: this.action
                },

                // empty form items, need to be present
                formItems: {},

                // default axios config set to post json
                axiosConfig: {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            };
        },
        methods: {
            recaptchaToken() {
                return new Promise((resolve) => {
                    grecaptcha.ready(async () => {
                        const token = await grecaptcha.execute(this.googleRecaptchaConfig.siteKey, {action: this.googleRecaptchaConfig.action});
                        resolve(token);
                    });
                });
            },
            setFormContents(data){
                this.form = data.form;
                this.allowSubmit = data.allowSubmit;
                let scripts = this.$el.querySelectorAll("script");
            },
            async formSubmit() {
                let apiPayload = {};
                apiPayload['captcha'] = await this.recaptchaToken();

                let apiFormInputs = this.$el.querySelectorAll("input");
                let index = 0;

                for (let i = 0; apiFormInputs.length > i; i++) {
                    if (apiFormInputs[index].type === 'hidden') {
                        apiPayload['_token'] = apiFormInputs[index].value;
                    } else {
                        apiPayload[apiFormInputs[i].dataset.field] = apiFormInputs[i].value;
                    }
                    index++;
                }

                let apiFormTextAreas = this.$el.querySelectorAll("textarea");
                for (let i = 0 ; apiFormTextAreas.length > i; i++) {
                    apiPayload[apiFormTextAreas[i].dataset.field] = apiFormTextAreas[i].value;
                    index++;
                }

                axios.post(
                    this.url,
                    JSON.stringify(apiPayload), this.axiosConfig)
                    .then(response => {
                        this.setFormContents(response.data);
                        // this.form = response.data.form;
                    })

            },
        },
        mounted() {
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + this.googleRecaptchaConfig.siteKey);
            document.head.appendChild(recaptchaScript);


            axios.get(this.url, this.axiosConfig).then(response => {
                this.setFormContents(response.data);
            });
        },
    };
</script>
